import mitt from 'mitt'
import smoothscroll from 'smoothscroll-polyfill'
import portm from '../axios/portm'
import { ENV_CONFIG_KEY } from '../consts'
import { isEnvProd } from './env'
import { setLocalStorage } from './storage'

// kick off the polyfill!
smoothscroll.polyfill()

const emitter = mitt()
window.$bus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
}

window.$io = new IntersectionObserver((entries) => {
  window.$bus.$emit('intersection-observer', entries)
})

/**
 * 处理iOS 微信客户端6.7.4 键盘收起页面未下移bug，20200220测试仍然有bug
 */
window.bodyScrollIntoViewEnd = () => {
  document.body.scrollIntoView({
    block: 'nearest',
    inline: 'nearest',
    behavior: 'smooth',
  })
}
;/iphone|ipod|ipad/i.test(navigator.appVersion) &&
  window.navigator.userAgent.toLowerCase().indexOf('weixin') !== -1 &&
  document.addEventListener('blur', window.bodyScrollIntoViewEnd, true)

async function initConfig() {
  if (isEnvProd()) return
  try {
    await portm('/zhenguo/activity/config/env', '', { hasTest: true }).then((res) => {
      setLocalStorage(ENV_CONFIG_KEY, res)
    })
  } catch (err) {
    // do nothing
  }
}

initConfig()
